<template>
  <div class="screen-wrapper" :style="screenWrapperStyle">
    <div class="screen" data-model-id="course:screen" :style="screenStyle">
      <img
        class="rectangle-7"
        alt="Rectangle"
        src="/static/img/course-rectangle-148387.svg"
        v-anim
      />
      <img
        class="rectangle-8"
        alt="Rectangle"
        src="/static/img/course-rectangle-148388.png"
        v-anim
        style="animation-delay:0.1s"
      />
      <CourseGroupSubsection v-anim />
      <img
        class="mask-group"
        alt="Mask group"
        src="/static/img/course-mask-group.png"
        v-anim="'animate__fadeInDown'"
      />
      <CourseJuniorClassesSubsection v-anim />
      <div class="text-wrapper-28" v-anim="'animate__fadeInDown'">课程体系</div>
      <HeaderSubsection
        :fixed="true"
        :logoSrc="'/static/img/course-image-506@2x.png'"
      />
      <div class="group-17" v-anim style="animation-delay:0.15s">
        <div class="text-wrapper-29">Course .</div>
        <div class="heading-services-4">课程体系</div>
      </div>
      <Group3Subsection :top="4388" v-anim />
    </div>
  </div>
</template>

<script>
import HeaderSubsection from "../Screen/sections/HeaderSubsection.vue";
import Group3Subsection from "../Screen/sections/Group3Subsection.vue";
import CourseGroupSubsection from "./sections/CourseGroupSubsection.vue";
import CourseJuniorClassesSubsection from "./sections/CourseJuniorClassesSubsection.vue";

export default {
  name: "CourseScreen",
  components: {
    HeaderSubsection,
    Group3Subsection,
    CourseGroupSubsection,
    CourseJuniorClassesSubsection,
  },
  directives: {
    anim: {
      inserted(el, binding) {
        const cls = binding && binding.value ? binding.value : 'animate__fadeInUp';
        el.classList.add('animate__animated');
        const io = new IntersectionObserver((entries)=>{
          entries.forEach(e=>{
            if (e.isIntersecting) {
              el.classList.add(cls);
              io.unobserve(el);
            }
          });
        }, { threshold: 0.2 });
        io.observe(el);
      }
    }
  },
  data() {
    return {
      baseWidth: 1920,
      baseHeight: 4621,
      targetWidth: 1920,
      viewportWidth: 0,
      viewportHeight: 0,
    };
  },
  computed: {
    scale1() {
      const w = this.viewportHeight || this.targetHeight;
      const clamped = Math.min(w, this.baseHeight);
      return this.baseHeight / clamped;
    },
    scale() {
      const w = this.viewportWidth || this.targetWidth;
      const clamped = Math.min(w, this.baseWidth);
      return clamped / this.baseWidth;
    },
    screenStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: "top center",
        width: this.baseWidth + "px",
        position: "relative",
        // background:'#ffffff',
        minHeight: this.baseHeight + "px",
      };
    },
    screenWrapperStyle() {
      return {
        width: "100%",
        height: this.baseHeight * this.scale + "px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",

        //  overflowX: "hidden",
      };
    },
  },
  mounted() {
    this.viewportWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.viewportWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    },
  },
};
</script>

<style scoped>
.screen {

  min-width: 1920px;
  
  position: relative;
  width: 100%;
}

.screen-wrapper {
  width: 100%;
  position: relative;
  overflow: visible;
}



.screen .rectangle-7 {
  height: 1118px;
  left: 0;
  position: absolute;
  top: 620px;
  width: 1920px;
}
.screen .rectangle-8 {
  height: 1118px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 620px;
  width: 1920px;
}
.screen .mask-group {
  height: 620px;
  left: 0;
  position: absolute;
  top: 0;
  width: 1920px;
}
.screen .text-wrapper-28 {
  color: #ffffff;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 36px;
  font-weight: 500;
  left: 885px;
  letter-spacing: 1.8px;
  line-height: 54px;
  position: absolute;
  top: 283px;
  white-space: nowrap;
}
.screen .group-17 {
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 98px;
  left: 180px;
  position: absolute;
  top: 740px;
  width: 302px;
}
.screen .text-wrapper-29 {
  color: #00183c;
  font-family: "Poppins", Helvetica;
  font-size: 72px;
  font-weight: 600;
  height: 36px;
  letter-spacing: 0;
  line-height: 36px;
  white-space: nowrap;
  width: 298px;
}
.screen .heading-services-4 {
  align-items: center;
  color: #00183c;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 32px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 30px;
  white-space: nowrap;
  width: 128px;
}
</style>
